export default __webpack_public_path__ + "static/media/bov_steg.62092929.jpg";